import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useGlobalStore } from '@/store/global';
import { useCartStore } from '@/store/cart';
import { ConfigProvider, DatePicker } from 'antd';
import moment from 'moment';
export default function CartCalendar() {
    const setDeliveryTime = useCartStore((state) => state.setDeliveryTime);
    const deliveryTime = useCartStore((state) => state.deliveryTime);
    const texts = useGlobalStore((state) => state.config.texts);
    const handleClick = (date, dateString) => {
        if (date !== null) {
            setDeliveryTime(date);
        }
    };
    const disabledDate = (current) => {
        // sunday = 0
        // monday = 1
        return current && (current < moment().endOf('day') // mozeme objednat na prechadzajuce dni
            || current > moment().add(14, 'days').endOf('day') // nemozeme objednat na dlhsie obdobie ako 2 tyzdne
            || new Date(current).getDay() === 6 // nemozeme objednat na sobotu
            || new Date(current).getDay() === 0 // nemozeme objednat a nedelu
            || (moment().day() === 5 && new Date(current).getDay() === 1) // nemozeme objednat z piatku na pondelok
            || (moment().day() === 6 && new Date(current).getDay() === 1) // nemozeme objednat zo soboty na pondelok
        // || (moment().day() === 0 && new Date(current).getDay() === 1) // nemozeme objednat zo nedele na pondelok
        );
    };
    return (_jsx(ConfigProvider
    // locale={csCZ}
    , { children: _jsx(DatePicker
        // locale={langData}
        , { 
            // locale={langData}
            format: 'DD.MM.YYYY', disabledDate: disabledDate, onChange: handleClick, superNextIcon: _jsx(_Fragment, {}), superPrevIcon: _jsx(_Fragment, {}), size: 'large', value: deliveryTime, placeholder: texts['text538'], showToday: false }) }));
}
